import { createBrowserClient } from '@supabase/ssr'
import { getPublicSupabaseConfig } from '@/lib/config/env'
import { softenRefreshFailure } from '@/lib/supabase/fetch'
// import type { Database } from './database.types'

/**
 * A 429 or 500 while refreshing the token must not end the session: auth-js
 * would delete the cookie on it. See `softenRefreshFailure`.
 */
const softenedFetch: typeof fetch = async (input, init) => {
  const response = await fetch(input, init)
  const url =
    typeof input === 'string' ? input : input instanceof URL ? input.href : (input as Request).url
  const method = (
    init?.method ?? (typeof input === 'object' && 'method' in input ? input.method : 'GET')
  ).toUpperCase()
  return softenRefreshFailure(method, url, response)
}

export function createClient() {
  const { url, anonKey } = getPublicSupabaseConfig()
  return createBrowserClient(url, anonKey, { global: { fetch: softenedFetch } })
}
